<template>
    <div class="ways">
      <el-carousel 
        id="ways-1"
        type="card"
        :interval="4000" 
        indicator-position="none"
        @change="swiperChange"
        height="100%">
          <el-carousel-item 
            v-for="item in swiperList" 
            :key="item.icon"
            :style="[{'--index': item.zIndex, '--left': item.mLeft}]" 
          >
            <img :src="item.icon" mode="aspectFill" class="ways-swiper-img" />
          </el-carousel-item>
      </el-carousel>
      <p class="ways-text-1" style="margin-top: 0.65rem;">解锁新玩法，畅享时光之旅</p>
      <p class="ways-text-2" style="margin-top: 0.59rem;">一键云升级 一台顶N台</p>
      <p class="ways-text-3" style="margin-top: 0;">档位自定义 智能数据同步</p>
      <div class="ways-iphone" id="ways-2" style="margin-top: 0.65rem;">
        <img class="ways-iphone-icon" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/iphone_1.png" />
        <img class="ways-iphone-icon" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/iphone_2.png" />
      </div>
      <p class="ways-text-2" style="margin-top: 0.59rem;">会员任务多样 享受多种权益</p>
      <p class="ways-text-3" style="margin-top: 0;">使用时间碎片 兑换心仪礼品</p>
      <div class="ways-iphone" style="margin-top: 0.59rem;">
        <img class="ways-iphone-icon" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/iphone_1.png" />
        <img class="ways-iphone-icon" src="https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/iphone_2.png" />
      </div>
      <p class="ways-text-3" style="margin-top: 0.59rem;">在流逝间丢失美，</p>
      <p class="ways-text-3" style="margin-top: 0;">也在和护理寻找美，</p>
      <p class="ways-text-3" style="margin-top: 0;">一个时间失去的，</p>
      <p class="ways-text-3" style="margin-top: 0;">可以在另一个时间找回，</p>
      <p class="ways-text-3" style="margin-top: 0;">时光之城助力你追寻美丽！</p>
      <mini-menu title="玩转MINIPIKA" />
    </div>
  </template>
   
  <script>
  import MiniMenu from "../components/MiniMenu.vue";
  export default {
    name: "Ways",
    components: {
      MiniMenu,
    },
    data() {
      return {
        swiperIndex: 0,
        swiperList: [
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/1.jpg', path: '', zIndex: 6, mLeft: 0},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/2.jpg', path: '', zIndex: 5, mLeft: 1},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/3.jpg', path: '', zIndex: 4, mLeft: 2},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/4.jpg', path: '', zIndex: 3, mLeft: 3},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/5.jpg', path: '', zIndex: 3, mLeft: 4},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/6.jpg', path: '', zIndex: 2, mLeft: 5},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/7.jpg', path: '', zIndex: 0, mLeft: -6},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/8.jpg', path: '', zIndex: 1, mLeft: -5},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/9.jpg', path: '', zIndex: 2, mLeft: -4},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/10.jpg', path: '', zIndex: 3, mLeft: -3},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/11.jpg', path: '', zIndex: 4, mLeft: -2},
          {icon: 'https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/12.jpg', path: '', zIndex: 5, mLeft: -1},
        ]
      }
    },
    methods: {
      swiperChange(pre, next) {
        this.swiperIndex = next
        const list = this.swiperList
        let isLeft = pre > next
        if (pre === this.swiperList.length - 1 && next === 0) {
          isLeft = false
        } else if (pre === 0 && next === this.swiperList.length - 1) {
          isLeft = true
        }
        if (!isLeft) {
          const mLeft = this.swiperList[0].mLeft
          const zIndex = this.swiperList[0].zIndex
          for (let i = 1; i < this.swiperList.length; i++) {
            list[i - 1].mLeft = this.swiperList[i].mLeft
            list[i - 1].zIndex = this.swiperList[i].zIndex
          }
          list[this.swiperList.length - 1].mLeft = mLeft
          list[this.swiperList.length - 1].zIndex = zIndex
        } else {
          const mLeft = this.swiperList[this.swiperList.length - 1].mLeft
          const zIndex = this.swiperList[this.swiperList.length - 1].zIndex
          for (let i = this.swiperList.length - 1; i > 0; i--) {
            list[i].mLeft = this.swiperList[i - 1].mLeft
            list[i].zIndex = this.swiperList[i - 1].zIndex
          }
          list[0].mLeft = mLeft
          list[0].zIndex = zIndex
        }
        this.swiperList = list
      }
    },
    mounted() {
    }
  };
  </script>
   
  <style lang="scss" scoped>
  .ways {
    width: 100%;
    padding-bottom: 0.82rem;
    background-image: url('https://minipika-stg-public.oss-cn-guangzhou.aliyuncs.com/home/ways/bg.png');
    background-position: 50% 50%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 0.7rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    &-swiper-img {
      width: 100%;
      height: 100%;
    }
    .el-carousel {
      width: 100%;
      aspect-ratio: 1920/845;
    }
    .el-carousel__item {
      width: 100%;
      height: 100%;
      z-index: calc(var(--index) - 4);
      transform: translateX(calc(10% * var(--left))) scaleX(calc(pow(0.9, 7 - var(--index)))) scaleY(calc(pow(0.9, 7 - var(--index)))) !important;
    }
    &-text-1 {
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 0.42rem;
      color: #FFFFFF;
      line-height: 0.52rem;
      text-align: center;
    }
    &-text-2 {
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 0.31rem;
      color: #FFFFFF;
      line-height: 0.63rem;
      text-align: center;
    }
    &-text-3 {
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 0.21rem;
      color: #FFFFFF;
      line-height: 0.63rem;
      text-align: center;
    }
    &-iphone {
      display: flex;
      flex-direction: row;
      column-gap: 0.28rem;
      &-icon {
        width: 2.16rem;
        height: 4.18rem;
      }
    }
  }
  </style>